var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card flex-md-row" }, [
    _c(
      "div",
      { staticClass: "card-body d-flex flex-column align-items-start p-2" },
      [
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-row align-items-center justify-content-between flex-nowrap w-100 mb-1",
          },
          [
            _c(
              "strong",
              { staticClass: "d-inline-block text-info text-break" },
              [
                _vm._v(
                  "\n                " + _vm._s(_vm.title) + "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "badge", class: _vm.classServiceCode }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.serviceCode) +
                  "\n            "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.abstract
          ? _c("p", { staticClass: "card-text text-left small mb-1" }, [
              _vm._v("\n            " + _vm._s(_vm.abstract) + "\n        "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row w-100" }, [
          _vm.name
            ? _c("div", { staticClass: "col-12 col-sm-auto" }, [
                _c(
                  "p",
                  {
                    staticClass:
                      "card-text small d-flex flex-nowrap align-items-center mb-0 mt-1",
                  },
                  [
                    _c("i", { staticClass: "fas fa-layer-group mr-2" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "d-inline-block text-break" }, [
                      _vm._v(_vm._s(_vm.name)),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceName
            ? _c("div", { staticClass: "col-12 col-sm-auto" }, [
                _c(
                  "p",
                  {
                    staticClass:
                      "card-text small d-flex flex-nowrap align-items-center mb-0 mt-1",
                  },
                  [
                    _c("i", { staticClass: "fas fa-earth-americas mr-2" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "d-inline-block text-break" }, [
                      _vm._v(_vm._s(_vm.serviceName)),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        !_vm.readonlyForm
          ? _c("div", { staticClass: "text-right w-100 mt-2" }, [
              !_vm.isCrossResource
                ? _c(
                    "a",
                    {
                      staticClass: "card-link",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.addResource.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t(`global.resources.list.actions.select`)
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.enableAddCrossResource
                ? _c(
                    "a",
                    {
                      staticClass: "text-nowrap card-link",
                      class: _vm.colorServiceCode,
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.addCrossResource.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t(`global.resources.list.actions.add_cross`)
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }